import axios from 'axios';
import {
  BASE_URL,
  PAGINATION,
  SEARCH,
  BIDDINGS_URL,
  RESTAURANT_ID_FILTER,
  CAPACITY_FILTER,
  DATE_FILTER,
  USER_ID_FILTER,
  AUCTION_ID_FILTER,
} from './Urls';
import {IParamsInfo} from './index.d';

export class BiddingApiModule {
  constructor() {}

  async getAllBiddings(paramInfo: IParamsInfo) {
    try {
      const response = await axios.get(
        BASE_URL +
          PAGINATION(BIDDINGS_URL, paramInfo.pageNo, paramInfo?.pageSize) +
          SEARCH(paramInfo?.searchKeyword) +
          RESTAURANT_ID_FILTER(paramInfo?.restaurantIdFilter) +
          CAPACITY_FILTER(paramInfo?.capacity) +
          DATE_FILTER(paramInfo?.startDate, paramInfo?.endDate) +
          USER_ID_FILTER(paramInfo?.userIdFilter) +
          AUCTION_ID_FILTER(paramInfo?.auctionIdFilter)
      );
      if (response.data.success) {
        return {
          status: response.status,
          success: true,
          data: response.data?.data || [],
          message: response.data.message,
        };
      }
      return {
        status: response.status,
        success: false,
        data: [],
        message: response.data.message,
      };
    } catch (error: any) {
      return {
        isNetwork: error.code === 'ERR_NETWORK',
        status: error?.response?.status,
        success: false,
        data: [],
        message: error.response.data.message || error.message,
      };
    }
  }
}
